import type { KeyboardEvent } from 'react';

/**
 * Arrow-key movement between the items of a menu or listbox, as their ARIA
 * roles promise: Down/Up to the next/previous item (wrapping), Home/End to the
 * first/last. Attach as the container's onKeyDown.
 */
export function moveFocusWithArrows(e: KeyboardEvent<HTMLElement>, itemSelector: string): void {
  const keys = ['ArrowDown', 'ArrowUp', 'Home', 'End'];
  if (!keys.includes(e.key)) return;
  const items = Array.from(e.currentTarget.querySelectorAll<HTMLElement>(itemSelector)).filter(
    (el) => !el.hasAttribute('disabled'),
  );
  if (items.length === 0) return;
  e.preventDefault();
  const at = items.indexOf(document.activeElement as HTMLElement);
  const next =
    e.key === 'Home'
      ? 0
      : e.key === 'End'
        ? items.length - 1
        : e.key === 'ArrowDown'
          ? (at + 1) % items.length
          : (at - 1 + items.length) % items.length;
  items[next]?.focus();
}
